import { render, staticRenderFns } from "./testPing.vue?vue&type=template&id=6eb15283&scoped=true"
import script from "./testPing.vue?vue&type=script&lang=js"
export * from "./testPing.vue?vue&type=script&lang=js"
import style0 from "./testPing.vue?vue&type=style&index=0&id=6eb15283&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb15283",
  null
  
)

export default component.exports